import React from "react";

const Icon = (props) => {
  return (
    <>
      <img
        className={props.className}
        onClick={props.onClick}
        src={"/images/icons/" + props.name}
        style={{
          cursor: "pointer",
          height: props.height,
          width: props.width,
          paddingRight: props.pr,
          paddingLeft: props.pl,
        }}
        alt="icon"
      />
    </>
  );
};

export default Icon;
